export const invite = {
  label: {
    emptyTitle: "No Invites Yet",
    emptyDescription: "When you get invited to join new organizations, they will show up here."
  }
}